import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { TypeIncidentDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-type-incident-select',
  templateUrl: './type-incident-select.component.html',
  styleUrls: ['./type-incident-select.component.css']
})
export class TypeIncidentSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.typesIncidents$) typesIncidents$: Observable<TypeIncidentDto[]>;

  @Input() width: number;

  @Input() typeIncidentId: number;
  @Output() typeIncidentIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  TypesIncidents: TypeIncidentDto[] = [];
  ColumnName = [];

  td: Subscription;

  constructor(
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Designation'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations.Designation);
    });
  }

  ngOnInit() {
    if (this.typeIncidentId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.typeIncidentId));
    }
    this.td = this.typesIncidents$.subscribe(res => {
      if (res != null) {
        this.TypesIncidents = res;
      }
    });
  }

  ngOnDestroy() {
    this.td?.unsubscribe();
  }

  updateInfo(event) {
    this.typeIncidentId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.typeIncidentId;
    if (!!this.cell && this.InitId !== this.typeIncidentId) {
      this.cell.setValue(this.typeIncidentId);
    }
    this.typeIncidentIdChange.emit(this.typeIncidentId);

    if(this.typeIncidentId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.typeIncidentId == null) {
      this.dataGrid.instance.clearSelection();
    }
  }
}
